// extracted by mini-css-extract-plugin
module.exports = {"awards":"Awards_awards__Dw2Qg","image_container":"Awards_image_container__HyVqf","col-6":"Awards_col-6__wmfKB"};